import { StyledWhiteContainer } from "features/metadesk/settings/common.styles";
import React from "react";
import StepContent from "./StepContent";
import { useIntl } from "react-intl";
import InputField from "@metacrm/metacrm-material-ui/dist/InputField";
import Grid from "@metacrm/metacrm-material-ui/dist/Grid";
import {
  StyledApiKeyCreatedTime,
  StyledFormTitle,
} from "../IntegrationWidgetSetting.styles";
import Button, {
  IconButton,
  SIZE,
  VARIANT,
} from "@metacrm/metacrm-material-ui/dist/Button";
import { Box } from "@mui/material";
import { formatCalendarDateAndTime } from "features/helpers/utils";
import { useConfirm } from "features/home/ConfirmDialogProvider";
import { tr } from "date-fns/locale";

export default function ApiKey({ apiKey, apiKeyCreated, handleRegenerate }) {
  const { formatMessage } = useIntl();
  const confirm = useConfirm();

  const onRegenerate = async () => {
    try {
      await confirm({
        title: formatMessage({
          id: "popup.regenerateApiKey.title",
        }),
        content: formatMessage({
          id: "popup.regenerateApiKey.description",
        }),
        confirmText: formatMessage({
          id: "global.btn.confirm",
        }),
        cancelText: formatMessage({
          id: "global.btn.cancel",
        }),
      });
      await handleRegenerate();
      confirm({
        title: formatMessage({ id: "widgetSettings.apiKey.regenerate" }),
        content: formatMessage({ id: "widgetSettings.apiKey.regenerateDesc" }),

        confirmText: formatMessage({ id: "global.btn.gotIt" }),
        color: "secondary",
      });
    } catch (e) {}
  };

  const apiSetting = {
    title: formatMessage({
      id: "widgetSettings.apiKey.title",
    }),
    describe: formatMessage({
      id: "widgetSettings.apiKey.description",
    }),
    content: (
      <>
        <StyledFormTitle center item xs={12} md={4}>
          {formatMessage({
            id: "widgetSettings.apiKey.input",
          })}
        </StyledFormTitle>
        <Grid position={"relative"} item xs={12} md={8}>
          <InputField
            disabled
            value={apiKey}
            endAdornment={
              <Button
                size={SIZE.XL}
                variant={VARIANT.TEXT}
                style={{ width: "100%", padding: "2px 0 2px 10px" }}
                onClick={onRegenerate}
              >
                {formatMessage({
                  id: "global.btn.regenerate",
                })}
              </Button>
            }
          ></InputField>
          <StyledApiKeyCreatedTime>
            <Box
              color={(theme) => theme.customColors.grey[600]}
              size="12px"
              mr="2.5px"
            >
              {formatMessage({
                id: "global.field.createdTime",
              })}{" "}
              :
            </Box>
            <Box color={(theme) => theme.customColors.purple[500]} size="12px">
              {formatCalendarDateAndTime(apiKeyCreated)}
            </Box>
          </StyledApiKeyCreatedTime>
        </Grid>
      </>
    ),
  };

  return <StepContent settingStep={apiSetting} />;
}
